import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import * as styles from './Container.module.css';

const Container = ({
  children,
  renderContainer = true,
  height = 'normal',
  className,
}) => {
  return (
    <div
      className={cn(className, styles.root)}
      data-variant={renderContainer ? null : 'without-container'}
      data-height={height}
    >
      <div className={styles.background} aria-hidden />

      <main className={styles.main}>{children}</main>
    </div>
  );
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  renderContainer: PropTypes.bool,
  className: PropTypes.string,
  withSearch: PropTypes.bool,
  height: PropTypes.oneOf(['normal', 'short']),
};

export default Container;
